import { render } from "./SurveyDevPanel.vue?vue&type=template&id=34a6609a&scoped=true"
import script from "./SurveyDevPanel.vue?vue&type=script&lang=js"
export * from "./SurveyDevPanel.vue?vue&type=script&lang=js"

import "./SurveyDevPanel.vue?vue&type=style&index=0&id=34a6609a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34a6609a"]])

export default __exports__